import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from './main.reducer';
import { MainFilter, Client, Account } from './main.models';
import { StaticData } from '../../global/interfaces';
import { getCurrencyByCountry } from '../../global/languages';

export const selectMainState = createFeatureSelector<State>('main');

export const selectMainClients = createSelector(selectMainState, (state: State) => state.clients);

export const selectMainFilter = createSelector(selectMainState, (state: State) => !!state ? state.filter : undefined);

export const selectMainFilterClient = createSelector(selectMainFilter, (state: MainFilter) =>
  !!state ? state.client : undefined
);

export const selectMainFilterAccount = createSelector(selectMainFilter, (state: MainFilter) => state.account);

export const selectMainFilterSelectedClient = createSelector(selectMainFilterClient, (filter: Client[]) =>
  filter && filter.length ? filter[0] : undefined
);

export const selectMainFilterSelectedAccount = createSelector(selectMainFilterAccount, (filter: Account[]) =>
  filter && filter.length ? filter[0] : undefined
);

export const selectClientCurrency = createSelector(selectMainFilterSelectedClient, (client: Client) =>
  !!client ? getCurrencyByCountry(client.country) : undefined
);

export const selectClientProductDocument = createSelector(selectMainFilterSelectedClient, (client: Client) =>
  !!client ? client.productDocument : undefined
);

export const selectStaticData = createSelector(selectMainState, (state: State) => state.staticData);

export const selectCountryWiseStaticData = createSelector(selectMainState, (state: State) => state.countryWiseStaticData);

export const selectTermsAndConditions = createSelector(selectStaticData, (state: StaticData) => state.terms || '');

export const selectDisclaimers = createSelector(selectStaticData, (state: StaticData) => state.importantNotices || '');

export const selectMainPageNotes = createSelector(selectMainState, (state: State) => state.pageNotes);

export const selectCountrySelected = createSelector(selectMainState, (state: State) => state.country);
